<template>
  <div class="p-table__content">
    <table>
      <thead>
        <tr>
          <th>
            {{ $t('pages.CompaniesTestimonials.textId') }}
            <span class="p-table__content__sort" :class="`is-${sortKey === 'text_id' && sortOrder}`" @click="$emit('sort', 'text_id')" />
          </th>
          <th>
            {{ $t('pages.CompaniesTestimonials.storeName') }}
          </th>
          <th>
            {{ $t('pages.CompaniesTestimonials.writtenAt') }}
            <span class="p-table__content__sort" :class="`is-${sortKey === 'written_at' && sortOrder}`" @click="$emit('sort', 'written_at')" />
          </th>
          <th>
            {{ $t('pages.CompaniesTestimonials.text') }}
          </th>
        </tr>
        <tr class="p-table__content__space"><td colspan="4" /></tr>
      </thead>
      <tbody>
        <tr
          v-for="(data, i) in datas"
          :key="i"
        >
          <td>
            {{ data.textId }}
          </td>
          <td>
            {{ data.storeName }}
          </td>
          <td>
            {{ basicDateTimeFormat(data.writtenAt) }}
          </td>
          <td v-html="comment(data.body)" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import moment from 'moment'
import { syntaxHighlight } from '../../modules/syntaxHighlight'
import { searchQueryAnalyzer } from 'src/biz_spa/modules/searchQueryAnalyzer'

export default {
  name: 'CompaniesTestimonialsTable',
  props: {
    datas: Array,
    sortKey: String,
    sortOrder: String,
  },
  emits: ['sort', 'text_id', 'sort', 'written_at', 'sort'],
  methods: {
    sort(key) {
      this.$emit('sort', key)
    },
    basicDateTimeFormat: function( date ) {
      return date ? moment( date ).format(this.$t('format.datetime.default')) : ''
    },
    comment(text) {
      const sanitizeText = DOMPurify.sanitize(text)
      return this.$route.query['query'] ? syntaxHighlight(sanitizeText, searchQueryAnalyzer(this.$route.query['query']), 'p-table__highlight') : sanitizeText
    },
  }
}
</script>

<style lang="scss" scoped>
.p-table__content {
  overflow-y: auto;
  max-height: 84vh;
  table {
    position: relative;
    z-index: 0;
  }
  thead {
    position: sticky;
    top: 0;
    z-index: 2;
  }
}
</style>
